import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export const create = () => {
	return class extends Controller {
		static values = {
			preventDefault: Boolean,
		};
		connect() {
			useClickOutside(this);
		}
		clickOutside(e) {
			if (['is-open'].some((cls) => this.element.classList.contains(cls))) {
				if (this.preventDefaultValue) e.preventDefault();
				this.element.classList.remove('is-open');
			}
		}
	};
};
